"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealTimeHandler = void 0;
var PubSubEvents_1 = require("../Services/PubSubEvents");
var BaseStore_1 = __importDefault(require("./BaseStore"));
var Entity_1 = __importDefault(require("./Entity"));
var RouteGenerator_1 = require("./RouteGenerator");
var RealTimeHandler = /** @class */ (function () {
    function RealTimeHandler(realTimeConnection) {
        this.realTimeConnection = realTimeConnection;
    }
    RealTimeHandler.prototype.on = function (eventName, eventHandler) {
        this.realTimeConnection.subscribe(new PubSubEvents_1.PubSubEvent(eventName), eventHandler);
    };
    RealTimeHandler.prototype.off = function (eventName, eventHandler) {
        this.realTimeConnection.unsubscribe(new PubSubEvents_1.PubSubEvent(eventName), eventHandler);
    };
    return RealTimeHandler;
}());
exports.RealTimeHandler = RealTimeHandler;
var StoreEntity = /** @class */ (function (_super) {
    __extends(StoreEntity, _super);
    function StoreEntity(_a) {
        var session = _a.session, entityName = _a.entityName, routes = _a.routes, routeSuffix = _a.routeSuffix;
        var _this = _super.call(this, { session: session, entityName: entityName, routes: routes, routeSuffix: routeSuffix }) || this;
        _this.isAllFetched = false;
        _this._onUpdate = [];
        _this._onCreate = [];
        _this._onDelete = [];
        _this._onEvent = {};
        _this.addOrUpdateByItem = function (item) {
            return _this.store.getItem(item.id) ? _this.store.updateInStore(item) : _this.store.addToStore(item);
        };
        _this.extract = function (response, extractor) {
            return extractor ? extractor(response) : (0, RouteGenerator_1.defaultExtractor)(response);
        };
        /*
        Realtime Event Handlers
         */
        _this.onCreate = function (entity) {
            _this._onCreate.forEach(function (fn) { return fn(entity); });
        };
        // TODO: create a separate method registerOnBatchCreate with infrastructure
        // to avoid union T | T[] here
        _this.registerOnCreate = function (fn) {
            _this._onCreate.push(fn);
            return function () { return _this._onCreate.splice(_this._onCreate.indexOf(fn), 1); };
        };
        _this.onUpdate = function (entity) {
            _this._onUpdate.forEach(function (fn) { return fn(entity); });
        };
        _this.registerOnUpdate = function (fn) {
            _this._onUpdate.push(fn);
            return function () { return _this._onUpdate.splice(_this._onUpdate.indexOf(fn), 1); };
        };
        _this.onDelete = function (entity) {
            _this._onDelete.forEach(function (fn) { return fn(entity); });
        };
        _this.registerOnDelete = function (fn) {
            _this._onDelete.push(fn);
            return function () { return _this._onDelete.splice(_this._onDelete.indexOf(fn), 1); };
        };
        _this.onEvent = function (eventType, entity) {
            if (_this._onEvent[eventType]) {
                _this._onEvent[eventType].forEach(function (fn) { return fn(entity); });
            }
        };
        _this.registerOnEvent = function (eventType, fn) {
            if (!_this._onEvent[eventType]) {
                _this.realTime.on(eventType, function (entity) {
                    _this.onEvent(eventType, entity);
                });
                _this._onEvent[eventType] = [];
            }
            _this._onEvent[eventType].push(fn);
            return function () { return _this._onEvent[eventType].splice(_this._onEvent[eventType].indexOf(fn), 1); };
        };
        _this.realTime = new RealTimeHandler(session.persistentConnection);
        _this.store = new BaseStore_1.default();
        return _this;
    }
    StoreEntity.prototype.getOrFetch = function (id, storeExtractor, requestExtractor) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.store.getItem(id) || this.fetchAndStore(id, storeExtractor, requestExtractor)];
            });
        });
    };
    StoreEntity.prototype.getAllOrFetch = function (request, storeExtractor, requestExtractor) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.isAllFetched) {
                    return [2 /*return*/, this.store.getItems()];
                }
                return [2 /*return*/, this.fetchAllAndStore(request, storeExtractor, requestExtractor)];
            });
        });
    };
    StoreEntity.prototype.create = function (request, storeExtractor, requestExtractor) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.create(request)];
                    case 1:
                        response = _a.sent();
                        this.storeItem(response, storeExtractor);
                        return [2 /*return*/, requestExtractor ? requestExtractor(response) : response];
                }
            });
        });
    };
    StoreEntity.prototype.bulkCreate = function (request, storeExtractor, requestExtractor) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.create(request)];
                    case 1:
                        response = _a.sent();
                        this.storeAllItems(response, storeExtractor);
                        return [2 /*return*/, requestExtractor ? requestExtractor(response) : response];
                }
            });
        });
    };
    StoreEntity.prototype.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.delete(id)];
                    case 1:
                        response = _a.sent();
                        this.store.removeFromStore(id);
                        return [2 /*return*/, response.success];
                }
            });
        });
    };
    StoreEntity.prototype.update = function (id, request, storeExtractor, requestExtractor) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.update(id, request)];
                    case 1:
                        response = _a.sent();
                        this.storeItem(response, storeExtractor);
                        return [2 /*return*/, requestExtractor ? requestExtractor(response) : response];
                }
            });
        });
    };
    StoreEntity.prototype.fetchAndStore = function (id, storeExtractor, requestExtractor) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.get(id)];
                    case 1:
                        response = _a.sent();
                        this.storeItem(response, storeExtractor);
                        return [2 /*return*/, requestExtractor ? requestExtractor(response) : response];
                }
            });
        });
    };
    StoreEntity.prototype.fetchAllAndStore = function (request, storeExtractor, requestExtractor) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.getAll(request)];
                    case 1:
                        response = _a.sent();
                        this.storeAllItems(response, storeExtractor);
                        this.isAllFetched = true;
                        return [2 /*return*/, requestExtractor ? requestExtractor(response) : response];
                }
            });
        });
    };
    StoreEntity.prototype.storeItem = function (response, storeExtractor) {
        var storeItem = this.extract(response, storeExtractor);
        this.addOrUpdateByItem(storeItem);
        return storeItem;
    };
    StoreEntity.prototype.storeAllItems = function (response, storeExtractor) {
        var _this = this;
        var storeItems = this.extract(response, storeExtractor);
        storeItems.forEach(function (item) { return _this.addOrUpdateByItem(item); });
        return storeItems;
    };
    return StoreEntity;
}(Entity_1.default));
exports.default = StoreEntity;
//# sourceMappingURL=StoreEntity.js.map